import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatIconModule } from '@angular/material/icon';
import { Router } from '@angular/router';
import { CommonService } from '../../services/common.service';
import { MatDialogRef } from '@angular/material/dialog';
import { AnalyticsService } from '../../services/analytics.service';

@Component({
  selector: 'app-need-help-popup-over',
  standalone: true,
  imports: [CommonModule, FlexLayoutModule, MatIconModule],
  templateUrl: './need-help-popup-over.component.html',
  styleUrl: './need-help-popup-over.component.scss'
})
export class NeedHelpPopupOverComponent {

  constructor(
    public dialogRef: MatDialogRef<NeedHelpPopupOverComponent>,
    private router: Router,
    public commonService: CommonService,
    private analyticsService: AnalyticsService
  ) { }

  raiseTicket() {
    this.router.navigate([`help-center/${this.commonService.getCookie('order_id')}/${this.commonService.getCookie('request_type')}`]);
    this.dialogRef.close();
  }

  callUs() {
    this.analyticsService.sendEvent('tracker_ivr_calls', {
      awb_number: this.commonService.getCookie('awb_number'),
      date: Date.now()
    })
    window.open('tel:+918068172518', '_self');
    this.dialogRef.close();
  }

  chatwithUs(){
    this.analyticsService.sendEvent('tracker_support_chatbot', {
      awb_number: this.commonService.getCookie('awb_number'),
      date: Date.now()
    })
    window.open('https://wa.me/918904938342?text=Hello%20Shadowfax', '_self');
    this.dialogRef.close();
  }
}
